import { render, staticRenderFns } from "./ChatEmojiPanel.vue?vue&type=template&id=3b3a10a0&scoped=true&"
import script from "./ChatEmojiPanel.vue?vue&type=script&lang=js&"
export * from "./ChatEmojiPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatEmojiPanel.vue?vue&type=style&index=0&id=3b3a10a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a10a0",
  null
  
)

export default component.exports